// Magazine-style layout with multiple articles per page, similar to Revista THC production data
export default [
    // Cover story
    {
        id: '1',
        type: 'article',
        title: 'The Future of Urban Living',
        pretitle: 'COVER STORY',
        author: 'Sarah Johnson',
        by_line: 'Senior Editor',
        body: '<div><p><strong>As cities evolve</strong>, architects and urban planners are reimagining how we live, work, and interact in metropolitan spaces.</p><p>The concept of the "15-minute city" is gaining traction worldwide, promising neighborhoods where everything residents need is within a short walk or bike ride.</p></div>',
        image_url: 'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=1200&q=80',
        image_caption: 'Future cityscape concept',
        start_page: 1,
        end_page: 3,
        location_in_start_page: { x: '25.0', y: '15.0' },
        location_in_end_page: { x: '75.0', y: '85.0' },
    },

    // Table of contents items on page 2
    {
        id: '100',
        type: 'article',
        title: "Editor's Letter",
        body: "<p>Brief content for Editor's Letter</p>",
        start_page: 2,
        end_page: 2,
        location_in_start_page: { x: '10.5', y: '12.3' },
    },
    {
        id: '101',
        type: 'article',
        title: 'Contributors',
        body: '<p>Brief content for Contributors</p>',
        start_page: 2,
        end_page: 2,
        location_in_start_page: { x: '10.5', y: '18.7' },
    },
    {
        id: '102',
        type: 'article',
        title: 'Letters to Editor',
        body: '<p>Brief content for Letters to Editor</p>',
        start_page: 2,
        end_page: 2,
        location_in_start_page: { x: '10.5', y: '25.1' },
    },
    {
        id: '103',
        type: 'article',
        title: 'Corrections',
        body: '<p>Brief content for Corrections</p>',
        start_page: 2,
        end_page: 2,
        location_in_start_page: { x: '10.5', y: '31.5' },
    },

    // Page 3 articles
    {
        id: '2',
        type: 'article',
        title: 'Breaking: Major Policy Change Announced',
        pretitle: 'NEWS',
        author: 'Miguel Fernández',
        by_line: 'NEWS Writer',
        body: '<div><p><strong>In a surprising turn of events</strong>, industry leaders have announced a major shift in strategy that could reshape the entire sector.</p><p>Experts are divided on the implications, with some praising the bold move while others express concern about potential risks.</p><p>"This is exactly what the industry needs," said one analyst. "It\'s time for change."</p></div>',
        start_page: 3,
        end_page: 3,
        location_in_start_page: { x: '12.5', y: '20.4' },
        content_metrics: {
            total_number_of_words: 450,
            reading_time_minutes: 2,
        },
    },
    {
        id: '3',
        type: 'article',
        title: 'The Case for Universal Healthcare',
        pretitle: 'OPINION',
        author: 'Anna Chen',
        by_line: 'OPINION Writer',
        body: '<div><p>Recent data shows a significant trend that could have far-reaching consequences.</p><p>According to the latest report:</p><ol><li>Growth has exceeded projections</li><li>New markets are emerging</li><li>Competition is intensifying</li></ol><p>Industry watchers are closely monitoring these developments.</p></div>',
        image_url: 'https://picsum.photos/400/300?random=3',
        image_caption: 'Image for article 3',
        image_name: 'article_3.jpg',
        start_page: 3,
        end_page: 4,
        location_in_start_page: { x: '55.8', y: '15.2' },
        location_in_end_page: { x: '45.3', y: '75.6' },
        content_metrics: {
            total_number_of_words: 780,
            reading_time_minutes: 3,
        },
    },

    // Page 4 articles
    {
        id: '4',
        type: 'article',
        title: 'The Renaissance of Local Art',
        pretitle: 'CULTURE',
        author: 'James Wilson',
        by_line: 'CULTURE Writer',
        body: '<div><p>The latest developments have caught many by surprise, signaling a new era in the field.</p><p>Key stakeholders are meeting this week to discuss the ramifications and chart a path forward.</p><ul><li>Initial reactions have been mixed</li><li>Long-term impacts remain unclear</li><li>Further announcements expected soon</li></ul></div>',
        start_page: 4,
        end_page: 4,
        location_in_start_page: { x: '18.3', y: '8.7' },
        content_metrics: {
            total_number_of_words: 320,
            reading_time_minutes: 2,
        },
    },
    {
        id: '5',
        type: 'article',
        title: 'AI Revolution Continues',
        pretitle: 'TECH',
        author: 'María González',
        by_line: 'TECH Writer',
        body: '<div><p><strong>After months of speculation</strong>, the announcement confirms what many suspected.</p><blockquote>"We\'re entering uncharted territory," said the spokesperson.</blockquote><p>The coming weeks will be crucial in determining the success of this initiative.</p></div>',
        image_url: 'https://picsum.photos/400/300?random=5',
        image_caption: 'Image for article 5',
        image_name: 'article_5.jpg',
        start_page: 4,
        end_page: 4,
        location_in_start_page: { x: '62.1', y: '55.9' },
        content_metrics: {
            total_number_of_words: 510,
            reading_time_minutes: 2,
        },
    },

    // Page 5 articles
    {
        id: '300',
        type: 'advertisement',
        title: 'Advertisement 1',
        advertiser: 'Premium Brand',
        start_page: 5,
        end_page: 5,
        location_in_start_page: { x: '35.2', y: '45.8' },
    },
    {
        id: '6',
        type: 'article',
        title: 'Wellness Trends for 2024',
        pretitle: 'LIFESTYLE',
        author: 'David Kim',
        by_line: 'LIFESTYLE Writer',
        body: '<div><p>The latest developments have caught many by surprise, signaling a new era in the field.</p><p>Key stakeholders are meeting this week to discuss the ramifications and chart a path forward.</p><ul><li>Initial reactions have been mixed</li><li>Long-term impacts remain unclear</li><li>Further announcements expected soon</li></ul></div>',
        start_page: 5,
        end_page: 5,
        location_in_start_page: { x: '10.5', y: '12.3' },
        content_metrics: {
            total_number_of_words: 420,
            reading_time_minutes: 2,
        },
    },
    {
        id: '7',
        type: 'article',
        title: 'Championship Season Preview',
        pretitle: 'SPORTS',
        author: 'Emma Thompson',
        by_line: 'SPORTS Writer',
        body: '<div><p><strong>In a surprising turn of events</strong>, industry leaders have announced a major shift in strategy that could reshape the entire sector.</p><p>Experts are divided on the implications, with some praising the bold move while others express concern about potential risks.</p><p>"This is exactly what the industry needs," said one analyst. "It\'s time for change."</p></div>',
        image_url: 'https://picsum.photos/400/300?random=7',
        image_caption: 'Image for article 7',
        image_name: 'article_7.jpg',
        start_page: 5,
        end_page: 6,
        location_in_start_page: { x: '58.7', y: '22.4' },
        location_in_end_page: { x: '32.1', y: '68.9' },
        content_metrics: {
            total_number_of_words: 890,
            reading_time_minutes: 4,
        },
    },

    // Page 6 articles
    {
        id: '8',
        type: 'article',
        title: 'Global Summit Reaches Agreement',
        pretitle: 'NEWS',
        author: 'Carlos Rivera',
        by_line: 'NEWS Writer',
        body: '<div><p>Recent data shows a significant trend that could have far-reaching consequences.</p><p>According to the latest report:</p><ol><li>Growth has exceeded projections</li><li>New markets are emerging</li><li>Competition is intensifying</li></ol><p>Industry watchers are closely monitoring these developments.</p></div>',
        start_page: 6,
        end_page: 6,
        location_in_start_page: { x: '15.8', y: '10.2' },
        content_metrics: {
            total_number_of_words: 340,
            reading_time_minutes: 2,
        },
    },
    {
        id: '9',
        type: 'article',
        title: 'Democracy in the Digital Age',
        pretitle: 'OPINION',
        author: 'Sarah Johnson',
        by_line: 'OPINION Writer',
        body: '<div><p><strong>After months of speculation</strong>, the announcement confirms what many suspected.</p><blockquote>"We\'re entering uncharted territory," said the spokesperson.</blockquote><p>The coming weeks will be crucial in determining the success of this initiative.</p></div>',
        start_page: 6,
        end_page: 6,
        location_in_start_page: { x: '60.4', y: '52.7' },
        content_metrics: {
            total_number_of_words: 275,
            reading_time_minutes: 1,
        },
    },

    // Page 7 articles
    {
        id: '10',
        type: 'article',
        title: 'Music Festivals Return Strong',
        pretitle: 'CULTURE',
        author: 'Miguel Fernández',
        by_line: 'CULTURE Writer',
        body: '<div><p>The latest developments have caught many by surprise, signaling a new era in the field.</p><p>Key stakeholders are meeting this week to discuss the ramifications and chart a path forward.</p><ul><li>Initial reactions have been mixed</li><li>Long-term impacts remain unclear</li><li>Further announcements expected soon</li></ul></div>',
        image_url: 'https://picsum.photos/400/300?random=10',
        image_caption: 'Image for article 10',
        image_name: 'article_10.jpg',
        start_page: 7,
        end_page: 7,
        location_in_start_page: { x: '25.3', y: '18.6' },
        content_metrics: {
            total_number_of_words: 560,
            reading_time_minutes: 3,
        },
    },
    {
        id: '11',
        type: 'article',
        title: 'Quantum Computing Breakthrough',
        pretitle: 'TECH',
        author: 'Anna Chen',
        by_line: 'TECH Writer',
        body: '<div><p><strong>In a surprising turn of events</strong>, industry leaders have announced a major shift in strategy that could reshape the entire sector.</p><p>Experts are divided on the implications, with some praising the bold move while others express concern about potential risks.</p><p>"This is exactly what the industry needs," said one analyst. "It\'s time for change."</p></div>',
        start_page: 7,
        end_page: 8,
        location_in_start_page: { x: '55.9', y: '60.1' },
        location_in_end_page: { x: '40.2', y: '82.5' },
        content_metrics: {
            total_number_of_words: 720,
            reading_time_minutes: 3,
        },
    },

    // Page 8 articles
    {
        id: '301',
        type: 'advertisement',
        title: 'Advertisement 2',
        advertiser: 'Premium Brand',
        start_page: 8,
        end_page: 8,
        location_in_start_page: { x: '48.6', y: '35.2' },
    },
    {
        id: '12',
        type: 'article',
        title: 'Sustainable Fashion Movement',
        pretitle: 'LIFESTYLE',
        author: 'James Wilson',
        by_line: 'LIFESTYLE Writer',
        body: '<div><p>Recent data shows a significant trend that could have far-reaching consequences.</p><p>According to the latest report:</p><ol><li>Growth has exceeded projections</li><li>New markets are emerging</li><li>Competition is intensifying</li></ol><p>Industry watchers are closely monitoring these developments.</p></div>',
        start_page: 8,
        end_page: 8,
        location_in_start_page: { x: '12.7', y: '8.9' },
        content_metrics: {
            total_number_of_words: 380,
            reading_time_minutes: 2,
        },
    },

    // Page 9 articles
    {
        id: '13',
        type: 'article',
        title: 'Rising Stars to Watch',
        pretitle: 'SPORTS',
        author: 'María González',
        by_line: 'SPORTS Writer',
        body: '<div><p><strong>After months of speculation</strong>, the announcement confirms what many suspected.</p><blockquote>"We\'re entering uncharted territory," said the spokesperson.</blockquote><p>The coming weeks will be crucial in determining the success of this initiative.</p></div>',
        image_url: 'https://picsum.photos/400/300?random=13',
        image_caption: 'Image for article 13',
        image_name: 'article_13.jpg',
        start_page: 9,
        end_page: 9,
        location_in_start_page: { x: '30.5', y: '25.8' },
        content_metrics: {
            total_number_of_words: 490,
            reading_time_minutes: 2,
        },
    },
    {
        id: '14',
        type: 'article',
        title: 'Economic Indicators Show Growth',
        pretitle: 'NEWS',
        author: 'David Kim',
        by_line: 'NEWS Writer',
        body: '<div><p>The latest developments have caught many by surprise, signaling a new era in the field.</p><p>Key stakeholders are meeting this week to discuss the ramifications and chart a path forward.</p><ul><li>Initial reactions have been mixed</li><li>Long-term impacts remain unclear</li><li>Further announcements expected soon</li></ul></div>',
        start_page: 9,
        end_page: 10,
        location_in_start_page: { x: '58.2', y: '55.3' },
        location_in_end_page: { x: '25.7', y: '70.8' },
        content_metrics: {
            total_number_of_words: 650,
            reading_time_minutes: 3,
        },
    },

    // Page 10 articles
    {
        id: '15',
        type: 'article',
        title: 'Climate Action: Now or Never',
        pretitle: 'OPINION',
        author: 'Emma Thompson',
        by_line: 'OPINION Writer',
        body: '<div><p><strong>In a surprising turn of events</strong>, industry leaders have announced a major shift in strategy that could reshape the entire sector.</p><p>Experts are divided on the implications, with some praising the bold move while others express concern about potential risks.</p><p>"This is exactly what the industry needs," said one analyst. "It\'s time for change."</p></div>',
        start_page: 10,
        end_page: 10,
        location_in_start_page: { x: '18.9', y: '12.4' },
        content_metrics: {
            total_number_of_words: 410,
            reading_time_minutes: 2,
        },
    },
    {
        id: '16',
        type: 'article',
        title: 'New Exhibition Opens Downtown',
        pretitle: 'CULTURE',
        author: 'Carlos Rivera',
        by_line: 'CULTURE Writer',
        body: '<div><p>Recent data shows a significant trend that could have far-reaching consequences.</p><p>According to the latest report:</p><ol><li>Growth has exceeded projections</li><li>New markets are emerging</li><li>Competition is intensifying</li></ol><p>Industry watchers are closely monitoring these developments.</p></div>',
        image_url: 'https://picsum.photos/400/300?random=16',
        image_caption: 'Image for article 16',
        image_name: 'article_16.jpg',
        start_page: 10,
        end_page: 10,
        location_in_start_page: { x: '62.5', y: '48.7' },
        content_metrics: {
            total_number_of_words: 520,
            reading_time_minutes: 2,
        },
    },

    // Page 11 articles
    {
        id: '302',
        type: 'advertisement',
        title: 'Advertisement 3',
        advertiser: 'Premium Brand',
        start_page: 11,
        end_page: 11,
        location_in_start_page: { x: '40.8', y: '50.3' },
    },
    {
        id: '17',
        type: 'article',
        title: "Social Media's Next Phase",
        pretitle: 'TECH',
        author: 'Sarah Johnson',
        by_line: 'TECH Writer',
        body: '<div><p><strong>After months of speculation</strong>, the announcement confirms what many suspected.</p><blockquote>"We\'re entering uncharted territory," said the spokesperson.</blockquote><p>The coming weeks will be crucial in determining the success of this initiative.</p></div>',
        start_page: 11,
        end_page: 11,
        location_in_start_page: { x: '15.2', y: '20.6' },
        content_metrics: {
            total_number_of_words: 360,
            reading_time_minutes: 2,
        },
    },

    // Page 12 - Special content with infographic
    {
        id: '202',
        type: 'image',
        title: 'Data Visualization: Market Trends',
        image_url: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80',
        image_caption: 'Q3 2024 Market Analysis',
        start_page: 12,
        end_page: 12,
        location_in_start_page: { x: '30.0', y: '20.0' },
    },
    {
        id: '18',
        type: 'article',
        title: 'Home Design Revolution',
        pretitle: 'LIFESTYLE',
        author: 'Miguel Fernández',
        by_line: 'LIFESTYLE Writer',
        body: '<div><p>The latest developments have caught many by surprise, signaling a new era in the field.</p><p>Key stakeholders are meeting this week to discuss the ramifications and chart a path forward.</p><ul><li>Initial reactions have been mixed</li><li>Long-term impacts remain unclear</li><li>Further announcements expected soon</li></ul></div>',
        image_url: 'https://picsum.photos/400/300?random=18',
        image_caption: 'Image for article 18',
        image_name: 'article_18.jpg',
        start_page: 12,
        end_page: 12,
        location_in_start_page: { x: '55.8', y: '60.2' },
        content_metrics: {
            total_number_of_words: 480,
            reading_time_minutes: 2,
        },
    },

    // Page 13 articles
    {
        id: '19',
        type: 'article',
        title: 'Team Rebuilds Strategy',
        pretitle: 'SPORTS',
        author: 'Anna Chen',
        by_line: 'SPORTS Writer',
        body: '<div><p><strong>In a surprising turn of events</strong>, industry leaders have announced a major shift in strategy that could reshape the entire sector.</p><p>Experts are divided on the implications, with some praising the bold move while others express concern about potential risks.</p><p>"This is exactly what the industry needs," said one analyst. "It\'s time for change."</p></div>',
        start_page: 13,
        end_page: 13,
        location_in_start_page: { x: '22.4', y: '15.8' },
        content_metrics: {
            total_number_of_words: 395,
            reading_time_minutes: 2,
        },
    },
    {
        id: '20',
        type: 'article',
        title: 'Historic Peace Deal Signed',
        pretitle: 'NEWS',
        author: 'James Wilson',
        by_line: 'NEWS Writer',
        body: '<div><p>Recent data shows a significant trend that could have far-reaching consequences.</p><p>According to the latest report:</p><ol><li>Growth has exceeded projections</li><li>New markets are emerging</li><li>Competition is intensifying</li></ol><p>Industry watchers are closely monitoring these developments.</p></div>',
        start_page: 13,
        end_page: 14,
        location_in_start_page: { x: '60.7', y: '52.3' },
        location_in_end_page: { x: '35.2', y: '78.6' },
        content_metrics: {
            total_number_of_words: 750,
            reading_time_minutes: 3,
        },
    },

    // Page 14 articles
    {
        id: '303',
        type: 'advertisement',
        title: 'Advertisement 4',
        advertiser: 'Premium Brand',
        start_page: 14,
        end_page: 14,
        location_in_start_page: { x: '52.3', y: '28.9' },
    },
    {
        id: '21',
        type: 'article',
        title: 'Why We Need to Rethink Education',
        pretitle: 'OPINION',
        author: 'María González',
        by_line: 'OPINION Writer',
        body: '<div><p><strong>After months of speculation</strong>, the announcement confirms what many suspected.</p><blockquote>"We\'re entering uncharted territory," said the spokesperson.</blockquote><p>The coming weeks will be crucial in determining the success of this initiative.</p></div>',
        start_page: 14,
        end_page: 14,
        location_in_start_page: { x: '10.8', y: '10.5' },
        content_metrics: {
            total_number_of_words: 440,
            reading_time_minutes: 2,
        },
    },

    // Page 15 - Video content
    {
        id: '200',
        type: 'video',
        title: 'Behind the Scenes: Magazine Production',
        description: 'Watch how our magazine comes to life each month',
        video_url: 'https://example.com/video.mp4',
        duration: '5:32',
        start_page: 15,
        end_page: 15,
        location_in_start_page: { x: '50.0', y: '70.0' },
    },
    {
        id: '22',
        type: 'article',
        title: 'Theatre Season Highlights',
        pretitle: 'CULTURE',
        author: 'David Kim',
        by_line: 'CULTURE Writer',
        body: '<div><p>The latest developments have caught many by surprise, signaling a new era in the field.</p><p>Key stakeholders are meeting this week to discuss the ramifications and chart a path forward.</p><ul><li>Initial reactions have been mixed</li><li>Long-term impacts remain unclear</li><li>Further announcements expected soon</li></ul></div>',
        image_url: 'https://picsum.photos/400/300?random=22',
        image_caption: 'Image for article 22',
        image_name: 'article_22.jpg',
        start_page: 15,
        end_page: 15,
        location_in_start_page: { x: '25.6', y: '22.3' },
        content_metrics: {
            total_number_of_words: 580,
            reading_time_minutes: 3,
        },
    },

    // Page 16 articles
    {
        id: '23',
        type: 'article',
        title: 'Cybersecurity Challenges Ahead',
        pretitle: 'TECH',
        author: 'Emma Thompson',
        by_line: 'TECH Writer',
        body: '<div><p><strong>In a surprising turn of events</strong>, industry leaders have announced a major shift in strategy that could reshape the entire sector.</p><p>Experts are divided on the implications, with some praising the bold move while others express concern about potential risks.</p><p>"This is exactly what the industry needs," said one analyst. "It\'s time for change."</p></div>',
        start_page: 16,
        end_page: 16,
        location_in_start_page: { x: '18.4', y: '30.7' },
        content_metrics: {
            total_number_of_words: 420,
            reading_time_minutes: 2,
        },
    },
    {
        id: '24',
        type: 'article',
        title: 'Travel Destinations Reopening',
        pretitle: 'LIFESTYLE',
        author: 'Carlos Rivera',
        by_line: 'LIFESTYLE Writer',
        body: '<div><p>Recent data shows a significant trend that could have far-reaching consequences.</p><p>According to the latest report:</p><ol><li>Growth has exceeded projections</li><li>New markets are emerging</li><li>Competition is intensifying</li></ol><p>Industry watchers are closely monitoring these developments.</p></div>',
        start_page: 16,
        end_page: 17,
        location_in_start_page: { x: '58.9', y: '55.2' },
        location_in_end_page: { x: '42.3', y: '65.8' },
        content_metrics: {
            total_number_of_words: 690,
            reading_time_minutes: 3,
        },
    },

    // Page 17 articles
    {
        id: '304',
        type: 'advertisement',
        title: 'Advertisement 5',
        advertiser: 'Premium Brand',
        start_page: 17,
        end_page: 17,
        location_in_start_page: { x: '28.5', y: '40.2' },
    },
    {
        id: '25',
        type: 'article',
        title: 'Olympic Preparations Begin',
        pretitle: 'SPORTS',
        author: 'Sarah Johnson',
        by_line: 'SPORTS Writer',
        body: '<div><p><strong>After months of speculation</strong>, the announcement confirms what many suspected.</p><blockquote>"We\'re entering uncharted territory," said the spokesperson.</blockquote><p>The coming weeks will be crucial in determining the success of this initiative.</p></div>',
        image_url: 'https://picsum.photos/400/300?random=25',
        image_caption: 'Image for article 25',
        image_name: 'article_25.jpg',
        start_page: 17,
        end_page: 17,
        location_in_start_page: { x: '12.3', y: '8.6' },
        content_metrics: {
            total_number_of_words: 510,
            reading_time_minutes: 2,
        },
    },

    // Page 18 - Audio/Podcast content
    {
        id: '201',
        type: 'audio',
        title: "Editor's Podcast: Industry Insights",
        description: 'Monthly discussion with industry leaders',
        audio_url: 'https://example.com/podcast.mp3',
        duration: '45:00',
        start_page: 18,
        end_page: 18,
        location_in_start_page: { x: '25.0', y: '80.0' },
    },
    {
        id: '26',
        type: 'article',
        title: 'Breaking: Economic Recovery Accelerates',
        pretitle: 'NEWS',
        author: 'Miguel Fernández',
        by_line: 'NEWS Writer',
        body: '<div><p>The latest developments have caught many by surprise, signaling a new era in the field.</p><p>Key stakeholders are meeting this week to discuss the ramifications and chart a path forward.</p><ul><li>Initial reactions have been mixed</li><li>Long-term impacts remain unclear</li><li>Further announcements expected soon</li></ul></div>',
        start_page: 18,
        end_page: 18,
        location_in_start_page: { x: '55.7', y: '25.4' },
        content_metrics: {
            total_number_of_words: 460,
            reading_time_minutes: 2,
        },
    },

    // Page 19 articles
    {
        id: '27',
        type: 'article',
        title: 'The Future of Democracy',
        pretitle: 'OPINION',
        author: 'Anna Chen',
        by_line: 'OPINION Writer',
        body: '<div><p><strong>In a surprising turn of events</strong>, industry leaders have announced a major shift in strategy that could reshape the entire sector.</p><p>Experts are divided on the implications, with some praising the bold move while others express concern about potential risks.</p><p>"This is exactly what the industry needs," said one analyst. "It\'s time for change."</p></div>',
        start_page: 19,
        end_page: 19,
        location_in_start_page: { x: '20.8', y: '35.2' },
        content_metrics: {
            total_number_of_words: 540,
            reading_time_minutes: 2,
        },
    },
    {
        id: '28',
        type: 'article',
        title: 'Art in the Digital Age',
        pretitle: 'CULTURE',
        author: 'James Wilson',
        by_line: 'CULTURE Writer',
        body: '<div><p>Recent data shows a significant trend that could have far-reaching consequences.</p><p>According to the latest report:</p><ol><li>Growth has exceeded projections</li><li>New markets are emerging</li><li>Competition is intensifying</li></ol><p>Industry watchers are closely monitoring these developments.</p></div>',
        image_url: 'https://picsum.photos/400/300?random=28',
        image_caption: 'Image for article 28',
        image_name: 'article_28.jpg',
        start_page: 19,
        end_page: 19,
        location_in_start_page: { x: '60.3', y: '58.7' },
        content_metrics: {
            total_number_of_words: 380,
            reading_time_minutes: 2,
        },
    },

    // Page 20 - Final page articles
    {
        id: '29',
        type: 'article',
        title: 'Next Issue Preview',
        pretitle: 'COMING SOON',
        author: 'Editorial Team',
        by_line: 'The Editors',
        body: "<div><p><strong>In our next issue</strong>, we explore the changing landscape of global technology and its impact on society.</p><p>Featured articles will include in-depth analyses of emerging trends, exclusive interviews with industry leaders, and groundbreaking research findings.</p><p>Don't miss our special report on the future of sustainable development.</p></div>",
        start_page: 20,
        end_page: 20,
        location_in_start_page: { x: '30.0', y: '40.0' },
        content_metrics: {
            total_number_of_words: 250,
            reading_time_minutes: 1,
        },
    },
];
